import {
  Anchor,
  Badge,
  Box,
  Button,
  Checkbox,
  CopyButton,
  Divider,
  Flex,
  Grid,
  Group,
  LoadingOverlay,
  Text,
  Tooltip,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconEyeSearch, IconX } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import {
  isNullOrUndefined,
  isNullOrUndefinedArry,
} from "../../../../_base/extension/StringExtension";
import Repository from "../../../../_base/helper/HttpHelper";
import { handleEditProductCategoryNew } from "../../../../api/ApiProduct";
import { API_ROUTE } from "../../../../const/apiRoute";
import { MessageResponse } from "../../../../model/MessageResponse";
import { CategoryTree } from "../../../../model/TblCategoryCommand";
import { useProductCreateStore } from "../../../../store/useProductCreateStore";
import OpenProductTab from "../../../../components/ProductTabs";
import ButtonClose from "../../../../common/ButtonClose/ButtonClose";
import { useNavigate } from "react-router-dom";

const ItemCategoryCommandNew = ({ info3 }: any) => {
  const navigate = useNavigate();
  const dataItemBase = useProductCreateStore((state) => state.dataItemBase);
  const setDataItemBase = useProductCreateStore(
    (state) => state.setDataItemBase
  );
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
  const { dataItemCategory, setDataItemCategory } = useProductCreateStore(); //danh mục mà sản phẩm đang thuộc về
  // console.log("list danh mục đang thuộc về", dataItemCategory);

  const [dataCategory, setDataCategory] = useState<CategoryTree[]>([]); //list danh mục cây
  const [error, setError] = useState<string | undefined>();
  const [visible, { open, close, toggle }] = useDisclosure(false);

  const [showAllCategories, setShowAllCategories] = useState(false); // Thêm trạng thái để hiển thị tất cả danh mục con

  const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);

  const handleClickCategoryName = (id: number) => {
    var element = document.getElementById(id.toString());
    if (element) {
      element.style.display =
        element.style.display === "block" ? "none" : "block";
    }
  };

  const handleChangeCheckBox = (category: CategoryTree, checked: boolean) => {
    const categoryId = category?.id;

    const updatedValues = dataItemCategory.filter(
      (selected) => selected?.categoryId !== categoryId
    );

    if (!checked) {
      setDataItemCategory(updatedValues);
    } else {
      const updatedValue = {
        ...category,
        categoryId: categoryId,
        categoryCode: category?.categoryCode,
        categoryName: category?.categoryName,
        idParent: category?.parentId,
        description: category?.description,
      };
      setDataItemCategory([...dataItemCategory, updatedValue]);
    }
  };

  const flattenCategoryTree = (
    categories: CategoryTree[],
    level = 0,
    idParent = 0
  ) => {
    return (
      <div
        id={idParent.toString()}
        style={{ display: level && !showAllCategories ? "none" : "block" }}
      >
        {(() => {
          // Chia danh sách categories thành các nhóm 12 mục
          const chunkedCategories = [];
          if (categories) {
            for (let i = 0; i < categories.length; i += 26) {
              chunkedCategories.push(categories.slice(i, i + 26));
            }
          }

          return (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
              {chunkedCategories.map((categoryChunk, columnIndex) => (
                <div
                  key={columnIndex}
                  style={{ flex: "1 0 auto", minWidth: "200px" }}
                >
                  {categoryChunk.flatMap((category) => (
                    <React.Fragment key={category?.id}>
                      <Flex pl={level * 30} mt={5}>
                        <Text mr={5} mt={-3}>
                          +
                        </Text>
                        <Checkbox
                          label={
                            category?.categoryChildModels.length > 0 ? (
                              <Anchor
                                underline="always"
                                href="javascript:void(0)"
                                onClick={() =>
                                  handleClickCategoryName(category?.id)
                                }
                              >
                                {category?.categoryName}
                              </Anchor>
                            ) : (
                              <Text>{category?.categoryName}</Text>
                            )
                          }
                          value={category?.id}
                          checked={
                            !!dataItemCategory.find(
                              (selected) =>
                                selected?.categoryId === category?.id
                            )
                          }
                          onChange={(e) =>
                            handleChangeCheckBox(
                              category,
                              e.currentTarget.checked
                            )
                          }
                        />
                      </Flex>

                      {category?.categoryChildModels.length > 0 &&
                        flattenCategoryTree(
                          category.categoryChildModels,
                          level + 1,
                          category.id
                        )}
                    </React.Fragment>
                  ))}
                </div>
              ))}
            </div>
          );
        })()}
      </div>
    );
  };

  // xử lý khi người dùng submit
  const handleSubmitForm = async () => {
    try {
      // Lọc bỏ các item có categoryId === 0 hoặc null
      const dataSubmit = dataItemCategory
        .filter(
          (item) =>
            item.categoryId !== 0 &&
            item.categoryId !== null &&
            item.categoryId !== undefined
        )
        .map((item) => ({
          id: item.id || 0,
          categoryCode: item.categoryCode || "",
          categoryName: item.categoryName || "",
          idParent: item.idParent !== undefined ? item.idParent : 0,
          description: item.description || "",
          createdBy: item.createdBy || "",
          lastUpdateDate: item.lastUpdateDate || "",
          lastUpdatedBy: item.lastUpdatedBy || "",
          lastUpdateLogin: item.lastUpdateLogin || "",
          orgId: item.orgId || 0,
          creationDate: item.creationDate || "",
          itemId: dataItemBase?.id,
          categoryId: item.categoryId,
        }));
      open();
      console.log("dataSubmit", dataSubmit);
      const response = await handleEditProductCategoryNew(dataSubmit);
      // console.log("response", response);
      if (response && response.success) {
        NotificationExtension.Success("Cập nhật danh mục sản phẩm thành công");
      } else {
        NotificationExtension.Fails(
          "Cập nhật danh mục sản phẩm không thành công"
        );
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    const callDataCategoryTree = async () => {
      open();
      try {
        let urlSearch =
          API_ROUTE.GET_CATEGORY_TREE +
          `?CategoryType=category&IsTradeIn=N&Skip=0&Take=2000`;
        let callapi = await repository.get<MessageResponse<CategoryTree[]>>(
          urlSearch
        );
        // console.log("callapi", callapi);
        if (
          isNullOrUndefined(callapi) ||
          isNullOrUndefinedArry(callapi?.data)
        ) {
          setDataCategory([]);
        } else {
          setDataCategory(callapi?.data ?? []);
        }
        return callapi?.data;
      } catch (error: any) {
        setError("Có lỗi xảy ra khi tải dữ liệu !");
        return null;
      } finally {
        close();
      }
    };
    callDataCategoryTree();
  }, []);
  const onNavigateOnWeb = () => {
    window.open(`${hacomUrl}/${dataItemBase?.url}`, "_blank");
  };
  return (
    <Box
      className="flex-none"
      component="form"
      mx="10px"
      style={{ position: "relative", minHeight: 500 }}
    >
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />
      <Flex justify={"space-between"} align={"center"} my={10}>
        <CopyButton value={String(dataItemBase?.itemName)} timeout={2000}>
          {({ copied, copy }) => (
            <Tooltip
              label={copied ? "Đã sao chép" : "Sao chép"}
              withArrow
              position="right"
            >
              <Badge
                color={copied ? "teal" : "blue"}
                onClick={copy}
                style={{ cursor: "pointer" }}
                size="lg"
              >
                {dataItemBase?.itemName}
              </Badge>
            </Tooltip>
          )}
        </CopyButton>
      </Flex>
      <Grid>
        <Grid.Col span={{ base: 12, md: 6, lg: 3.25 }}>
          <Text fw={600} mt={"xs"}>
            Hiện tại sản phẩm đang được đặt trong các danh mục sau :
          </Text>

          <Flex direction={"column"}>
            {dataItemCategory?.map((category, index) => (
              <Text
                style={{
                  whiteSpace: "pre",
                }}
                key={index}
              >
                <strong
                  style={{
                    color: "#3598dc",
                    fontWeight: 500,
                  }}
                >
                  - {category?.categoryName}
                </strong>
              </Text>
            ))}
          </Flex>
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 0.5 }}>
          <Divider size="sm" h={"100%"} orientation="vertical" ml={10} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 8.25 }}>
          <Text mt={"xs"} fw={600}>
            Hãy chọn danh mục cho sản phẩm
          </Text>

          {/* Nút hiển thị tất cả danh mục con */}
          <Button
            color="blue"
            variant="outline"
            onClick={() => setShowAllCategories(!showAllCategories)}
            mb="md"
          >
            {showAllCategories
              ? "Ẩn tất cả danh mục con"
              : "Hiển thị tất cả danh mục con"}
          </Button>

          <Box>{flattenCategoryTree(dataCategory || [])}</Box>
        </Grid.Col>
      </Grid>

      <Group
        justify="flex-end"
        mt="lg"
        pt={"10px"}
        style={{ position: "sticky", bottom: 10, backgroundColor: "white" }}
      >
        {info3 !== "info3" && (
          <>
            <Button
              type="button"
              color="#3598dc"
              leftSection={<IconEyeSearch size={18} />}
              onClick={() => onNavigateOnWeb()}
            >
              Xem trên web
            </Button>
            <OpenProductTab
              productId={dataItemBase?.id}
              itemCode={dataItemBase?.itemName ?? ""}
              tabToOpen="info2"
              buttonText="Mở trang tab"
            />
          </>
        )}

        <Button
          type="button"
          color="#3598dc"
          onClick={(e) => {
            handleSubmitForm();
          }}
          leftSection={<IconCheck size={18} />}
        >
          Lưu
        </Button>
        <Button
          color="red"
          onClick={() => {
            navigate(-1);
          }}
          leftSection={<IconX size={18} />}
        >
          Đóng
        </Button>
      </Group>
    </Box>
  );
};

export default React.memo(ItemCategoryCommandNew);
